import {ScheduleResult} from "./schedule_result";
import './search_slide_block.css';
import {SearchRoutesContainer} from "../search_container";

export const SearchSlide = {
    props: {},
    components: {
        ScheduleResult
    },
    async created()
    {
        await this.init();
    },
    mounted()
    {
        this.$Bitrix.eventEmitter.subscribe('akatan:order_ticket:autofill', this.autofill)
        this.ResizeHandler();
        window.addEventListener("resize", this.ResizeHandler);
    },
    beforeUnmount()
    {
        this.$Bitrix.eventEmitter.unsubscribe('akatan:order_ticket:autofill', this.autofill)
    },
    data(): object {
        return {
            bus_stations: [],

            errors: {},

            form: {
                departure: null,
                arrival: null,
                date: '',
            },

            isMobile: false,

            search: {
                departure: {
                    'Id': '',
                    'Name': '',
                },
                arrival: {
                    'Id': '',
                    'Name': '',
                },
                date: '',
            },

            isSchedule: false,

            schedule:{
                today: {
                    date: '',
                    trips: [],
                },
                tomorrow: {
                    date: '',
                    trips: [],
                },
                //all: {},
            }
        }
    },
    watch: {
        'form.departure'(departure) {
            this.search.departure = this.bus_stations[departure];
        },
        'form.arrival'(arrival) {},
        'form.date'(date) {
            this.search.date = date;
        },
    },
    methods: {
        async init()
        {
            await this.loading_on();

            try {
                this.bus_stations = await this.getStations();
                await this.initSearchForm();
            } catch (error) {
                console.error(error)
            } finally {
                this.loading_off();
            }
        },

        async searchSchedules()
        {
            await this.loading_on();
            const params = {
                status: 'get_schedules',
                search: {
                    depot: this.search.departure.Id,
                    settlement: this.search.arrival.Id,
                    date: this.search.date,
                },
                ajax: 'yes',
            };
            const  jsonData = JSON.stringify(params);
            try {
                const response = await fetch(
                    '/local/js/akatan/search_routes/ajax.php',
                    {
                        method: 'POST',
                        headers: new Headers({
                            "Content-Type": "application/json",
                        }),
                        body: jsonData,
                    }
                );
                const res_schedules = await response.json();
                if (res_schedules.state === 'success') {
                    this.schedule = res_schedules.suggestions.schedule;
                    this.isSchedule = true;
                }
                if (res_schedules.state === 'error') {
                    this.isSchedule = false;
                    this.handlerErrors(res_schedules.suggestions);
                }
            } catch (error) {
                this.isSchedule = false;
                console.error(error)
            } finally {
                this.loading_off();
            }
        },

        async getStations()
        {

            this.loading_on();
            const params = {
                status: 'get_bus_station',
                ajax: 'yes',
            };
            const  jsonData = JSON.stringify(params);
            try {
                const response = await fetch(
                    '/local/js/akatan/search_routes/ajax.php',
                    {
                        method: 'POST',
                        headers: new Headers({
                            "Content-Type": "application/json",
                        }),
                        body: jsonData,
                    }
                );
                const res_bus_station = await response.json();
                if (res_bus_station.state === 'success') {
                    return res_bus_station.suggestions.BUS_STATIONS;
                }
                if (res_bus_station.state === 'error') {
                    this.handlerErrors(res_bus_station.suggestions);
                }
            } catch (error) {
                console.error(error)
            }
        },

        async initSearchForm()
        {
            this.loading_on();
            const params = {
                status: 'init_form',
                ajax: 'yes',
            };
            const  jsonData = JSON.stringify(params);
            try {
                const response = await fetch(
                    '/local/js/akatan/search_routes/ajax.php',
                    {
                        method: 'POST',
                        headers: new Headers({
                            "Content-Type": "application/json",
                        }),
                        body: jsonData,
                    }
                );
                const res_init_form = await response.json();
                if (
                    res_init_form.state === 'success' &&
                    typeof res_init_form.suggestions !== 'undefined' &&
                    typeof res_init_form.suggestions !== 'null' &&
                    typeof res_init_form.suggestions.form !== 'undefined'
                ) {
                    this.search = res_init_form.suggestions.form;
                    this.form = {
                        "departure": this.search.departure.Id,
                        "arrival": this.search.arrival.Name,
                        "date": this.search.date,
                    };
                    await this.searchSchedules();

                }
            } catch (error) {
                console.error(error)
            }
        },

        handlerErrors(errors)
        {
            if (
                typeof errors.error_message !== 'undefined'
            ) {
                this.errors = errors.error_message;
            } else if (typeof errors.error_text !== 'undefined') {
                this.errors = errors.error_text;
            }
        },

        autofill(event)
        {
            const {autofill} = event.getData();
            if (
                autofill.autofill.data !== 0
            ) {
                this.search.arrival = autofill.autofill.data;
                this.form.arrival = autofill.autofill.value;
            } else {
                this.form.arrival = {
                    "Id": "",
                    "Name": ""
                };
            }
        },

        loading_on()
        {
            this.$Bitrix.eventEmitter.emit('akatan:search_routes:loading_on', {});
        },

        loading_off()
        {
            this.$Bitrix.eventEmitter.emit('akatan:search_routes:loading_off', {});
        },

        ResizeHandler()
        {
            let mtm = (window.matchMedia('(max-width: 992px)'));
            this.isMobile = mtm.matches;
        },
    },
    template: `
    <div class="buy-ticket">
        <div class="buy-ticket__form">
            <form id="form_request" method="post" class="buyTicket_form horisontal-search-block js-searchform">
                <div class="buyTicket_form-field buyTicket_form-field-select">
                    <span
                        class="depot error"
                        v-if="typeof errors.depot !== 'undefined' && typeof errors.depot.errordescription !== 'undefined'"
                    >{{errors.depot.errordescription}}</span>
                    <styler-departure v-if="typeof bus_stations === 'object' && Object.keys(bus_stations).length > 0" v-model="form.departure" :options="bus_stations"></styler-departure>
                </div>
                <div class="arrows"></div>
                <div class="buyTicket_form-field">
                    <span
                        class="settlement error"
                        v-if="typeof errors.settlement !== 'undefined' && typeof errors.settlement.errordescription !== 'undefined'"
                    >{{errors.settlement.errordescription}}</span>
                    <settlement-input v-model="form.arrival" :depotId="search.departure.Id"></settlement-input>
                </div>
                <div class="buyTicket_form-field">
                    <span
                        class="date error"
                        v-if="typeof errors.date !== 'undefined' && typeof errors.date.errordescription !== 'undefined'"
                    >{{errors.date.errordescription}}</span>
                    <from-datepicker v-model="form.date"></from-datepicker>
                </div>
                <div class="buyTicket_form-field">
                    <button class="buyTicket_form-field-button accent" type="submit" @click.stop.prevent="searchSchedules">
                        Начать поиск
                    </button>
                </div>
            </form>
        </div>

        <ScheduleResult
            :is_active="isSchedule"
            :is_mobile="isMobile"
            :departure="search.departure.Name"
            :arrival="search.arrival.Name"
            :date="search.date"
            :schedule="schedule"
        ></ScheduleResult>
    </div>
    `
}